/**
 * HistoryPage - Página do Histórico (rotas /history e /history/:contactId/:channelId)
 *
 * Mesmo layout do chat: sidebar esquerda (aba Histórico ativa, lista agrupada
 * por contato+canal) + área principal. Com par selecionado na URL, a área
 * principal vira uma conversa read-only (HistoryConversationView) com todas
 * as mensagens dos atendimentos finalizados do par.
 *
 * A antiga /history/:contactId (ContactHistoryPage, clique no contato da aba
 * Contatos) foi REMOVIDA em 2026-07-02 — clique em contato não navega mais.
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ChatSidebarLeft from '../components/ChatSidebarLeft';
import HistoryConversationView from '../components/HistoryConversationView';
import { useChatPreferences } from '../hooks';
import { Icon } from '@/shared/icons';

export const HistoryPage: React.FC = () => {
  const { contactId, channelId } = useParams<{ contactId?: string; channelId?: string }>();
  const navigate = useNavigate();

  const { leftSidebarExpanded, setLeftSidebarExpanded } = useChatPreferences();

  return (
    <div
      className="h-full w-full overflow-hidden"
      style={{ backgroundColor: 'var(--theme-page-background)' }}
    >
      <div className="flex h-full w-full">
        {/* LEFT SIDEBAR — mesma do chat, aba Histórico ativa */}
        <div
          className={`flex-shrink-0 transition-all duration-300 relative z-10 overflow-visible ${
            leftSidebarExpanded ? 'w-96' : 'w-16'
          }`}
        >
          <ChatSidebarLeft
            expanded={leftSidebarExpanded}
            onToggle={() => setLeftSidebarExpanded(prev => !prev)}
            selectedConversationId={null}
            onSelectConversation={(id) => navigate(`/chat/${id}`)}
            initialView="history"
          />
        </div>

        {/* MAIN — conversa de histórico ou estado vazio */}
        <div
          className="flex-1 flex flex-col"
          style={{ backgroundColor: 'var(--theme-page-background)' }}
        >
          {contactId && channelId ? (
            <HistoryConversationView contactId={contactId} channelId={channelId} />
          ) : (
            <div className="flex-1 flex items-center justify-center" data-testid="history-page-empty">
              <div className="text-center">
                <div
                  className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3"
                  style={{ backgroundColor: 'var(--theme-card-background)' }}
                >
                  <Icon name="clock" className="w-8 h-8" style={{ color: 'var(--theme-muted-text)' }} />
                </div>
                <h3 className="font-semibold mb-1" style={{ color: 'var(--theme-card-text)' }}>
                  Histórico de atendimentos
                </h3>
                <p className="text-sm" style={{ color: 'var(--theme-muted-text)' }}>
                  Selecione um contato na lista para ver todas as conversas finalizadas
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HistoryPage;
